import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClientContract, PaymentPlanEnum } from 'src/app/shared/models/clients/clientContract';
import { Service } from 'src/app/shared/models/services/service';
import { ServicesCreateEditComponent } from 'src/app/shared/settings/services-create-edit/services-create-edit.component';

@Component({
  selector: 'app-contract-form',
  templateUrl: './contract-form.component.html',
  styleUrls: ['./contract-form.component.scss']
})
export class ContractFormComponent implements OnInit {
  @Input() contract: ClientContract;
  contractCopy: ClientContract;
  @Output() submitContract: EventEmitter<ClientContract> = new EventEmitter<ClientContract>();
  @ViewChild('serviceModal') serviceModal: ServicesCreateEditComponent;
  services: Service[] = [];
  paymentPlanEnum = PaymentPlanEnum;


  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
  ) {
    this.route.data.subscribe(resolverData => {
      this.services = resolverData.services.results;
    });
  }

  ngOnInit(): void {
    if (!this.contract.id) {
      this.contract.relationship = this.services[0];
    }
    this.contractCopy = Object.assign(new ClientContract(), this.contract);
  }

  onSubmit() {
    this.submitContract.emit(this.contractCopy);
  }

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

  addServiceFn = (ship) => this.addItemFn(new Service(), ship, this.serviceModal, 'name');

  serviceSubmit(service: Service) {
    this.contractCopy.services.push(service);
    this.serviceModal.close();
    this.toastr.success('Service added', 'Success!');
  }

  setContractRelationship(service: Service) {
    this.contractCopy.relationship = service;
  }

}
